module.exports = __webpack_public_path__ + "6ccae7384a23d80a9547539cdadd9289.svg";